




























import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user/user.store';
import { NotificationApi } from '@/services/api/api.notifications';
import Notification from '@/components/frontpage/notifications/Notification.vue';

@Component({
    components: { Notification }
})
export default class Notifications extends Vue {
    get notifications() {
        return UserModule.notifications;
    }

    get unreadNotifications() {
        return UserModule.unseenNotifications;
    }

	loading: boolean = false;

	async markAllAsread() {
	    this.loading = true;

	    try {
	        const result = await NotificationApi.MarkAllNotificationsAsRead();

	        this.$bvToast.toast(`Notifications read successfully.\n\n${result.message}`, {
	            variant: 'success',
	            title: 'Success'
	        });

	        UserModule.MarkAllNotificationsAsRead();
	    } finally {
	        this.loading = false;
	    }
	}

	async getNotifications() {
	    this.loading = true;

	    try {
	        await UserModule.GetNotifications();
	    } finally {
	        this.loading = false;
	    }
	}
}
